import * as React from 'react';

import {InlineTextButton} from '../button/inline-text-button/inline-text-button';
import {colors} from '../colors/colors';
import {ErrorCircleIcon} from '../icon';

import styles from './email-row-item.module.css';

type Props = {
    retry: () => Promise<any>;
};

export function EmailRowItemError(props: Props) {
    return (
        <div className={styles['email-row-item--expanded']}>
            <div className='flex justify-center align-center' style={{marginTop: -3}}>
                <div style={{color: colors.error}}>
                    <ErrorCircleIcon size={24} />
                </div>
                <span style={{marginLeft: 4}}>
                    Unable to load email. Please{' '}
                    <InlineTextButton
                        onClick={() => {
                            props.retry();
                        }}
                    >
                        retry
                    </InlineTextButton>{' '}
                    or contact support.
                </span>
            </div>
        </div>
    );
}
